import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const CoffeeCup = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M17 11.6V15C17 18.3137 14.3137 21 11 21H9C5.68629 21 3 18.3137 3 15V11.6C3 11.2686 3.26863 11 3.6 11H16.4C16.7314 11 17 11.2686 17 11.6Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M12 9C12 8 12.7143 7 14.1429 7V7C15.7208 7 17 5.72081 17 4.14286V3.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M8 9V8.5C8 6.84315 9.34315 5.5 11 5.5V5.5C12.1046 5.5 13 4.60457 13 3.5V3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M16 11H18.5C19.8807 11 21 12.1193 21 13.5C21 14.8807 19.8807 16 18.5 16H17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { CoffeeCup };